<div class="p-4 w-full">

  <div class="w-full flex justify-start items-center lg:p-4">
    <i class="ico-Close cursor-pointer text-xl ml-3" (click)="closeModal()"></i>
    <h3 class="text-lg">قوانین و مقررات {{modalData.headerComments.Name}}</h3>
  </div>
  <!-- <div class="w-full flex justify-start items-center text-xl font-medium tracking-tight ">
        {{ modalData.headerComments.Name }}
    </div> -->
  <div class="wrapper w-full space-y-6 mt-6 h-[88vh] overflow-y-auto lg:h-auto lg:overflow-visible">

    <section class="grid grid-cols-2 md:grid-cols-4 gap-6 mt-4">
      <div class="justify-start items-start hidden font-bold md:flex">ساعت ورود
        و خروج</div>
      <div class="grid grid-cols-1 gap-2 justify-center items-center">
        <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md p-2">
          <div class="flex justify-center items-center text-black-300 gap-2">
            <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
            <div class="text-sm">ساعت ورود</div>
          </div>
          <div class="text-black font-bold">{{
            modalData.headerComments.Policies.CheckInTime }}</div>
        </div>
        <div class="hidden justify-center space-x-1 items-center text-black-300 gap-2">
          <div><i class="ico-Check flex justify-center items-center"></i></div>
          <div class="text-sm">ورود زود هنگام</div>
          <div><i class="ico-InformationCircle flex justify-center items-center"></i>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-2 justify-center items-center">
        <div class="flex flex-col justify-center items-center bg-metal-50 rounded-md p-2">
          <div class="flex justify-center items-center text-black-300 gap-2">
            <div><i class="ico-TimeCircle flex justify-center items-center"></i></div>
            <div class="text-sm">ساعت خروج</div>
          </div>
          <div class="text-black font-bold">{{
            modalData.headerComments.Policies.CheckOutTime }}</div>
        </div>
        <div class="hidden justify-center space-x-1 items-center text-black-300 gap-2">
          <div><i class="ico-Check flex justify-center items-center"></i></div>
          <div class="text-sm hidden">خروج زود هنگام</div>
          <div><i class="ico-InformationCircle flex justify-center items-center"></i></div>
        </div>
      </div>

    </section>
    <!-- <section *ngIf="modalData.headerComments.HotelSeasonNote && (modalData.headerComments.HotelSeasonNote?.HotelSeasonNote || modalData.headerComments.HotelSeasonNote?.HotelNoroozNote)" class="mt-4">
        <iho-season-tips [season]="modalData.headerComments.HotelSeasonNote?.HotelSeasonNote?.Season"
        [seasonNote]="modalData.headerComments.HotelSeasonNote?.HotelSeasonNote?.Descriptions"
        [hotelName]="modalData.headerComments.Name"
        [nowruz]="modalData.headerComments.HotelSeasonNote?.HotelNoroozNote ? true : false"
        [nowruzDescription]="modalData.headerComments.HotelSeasonNote?.HotelNoroozNote ? modalData.headerComments.HotelSeasonNote?.HotelNoroozNote?.Descriptions : []"/>
    </section> -->
    <section class="flex flex-col justify-between items-center md:items-start">
      <div class="grid grid-cols-1 md:grid-cols-6 space-x-4 justify-between items-start mt-6"
        *ngIf="!['', null, undefined].includes(modalData.headerComments.Policies.PolicyHotelChild)">
        <div class="w-full md:col-span-1 text-base font-bold md:mt-0">قانون
          خردسال</div>
        <div
          class="w-full md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 lg:!mr-11 mt-2 md:mt-0 text-sm"
          [innerHTML]="modalData.headerComments.Policies.PolicyHotelChild">
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-6 space-x-4 justify-between items-start mt-6"
        *ngIf="!['', null, undefined].includes(modalData.headerComments.Policies.PolicyHotelChecking)">
        <div class="w-full md:col-span-1 text-base font-bold">قانون ورود و
          خروج</div>
        <div
          class="w-full md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 md:!mr-3 mt-2 md:mt-0 text-sm"
          [innerHTML]="modalData.headerComments.Policies.PolicyHotelChecking">
        </div>
      </div>
      <div class="w-full text-base text-right text-black-500 font-bold mt-12">اطلاعات
        مهم دیگر</div>
      <div class="grid grid-cols-1 mt-2">
        <div class="col-span-5 space-y-4">
          <div class *ngFor="let policy of modalData.headerComments.Policies.PolicyGroup">
            <div class="text-base text-right leading-7">{{ policy.Name }}</div>
            <div class="text-black-300 mt-2 text-sm !font-normal leading-7">
              <ul>
                <li *ngFor="let policy of policy.Policies" class="mb-1">{{
                  policy }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full grid grid-cols-1 md:grid-cols-6 justify-between items-start mt-6"
        *ngIf="!['', null, undefined].includes(modalData.headerComments.Policies.PolicyHotelCancellation)">
        <div class="w-full md:col-span-1 text-base font-bold md:mt-0">قانون
          کنسلی هتل</div>
        <div
          class="w-full md:col-span-5 flex flex-col justify-start items-start text-black-300 space-y-3 leading-7 lg:!mr-11 mt-2 md:mt-0 text-sm"
          [innerHTML]="modalData.headerComments.Policies.PolicyHotelCancellation">
        </div>
      </div>
    </section>
  </div>
</div>